module.exports = __webpack_public_path__ + "static/media/combo_4.0d3df7fe.png";